import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { ItemKind } from "dto/IKindItems";
import {
  IEuroOfficeDocument,
  IEuroOfficeSession,
  IEuroOfficeSessionRequest,
  IEuroOfficeStatus,
} from "dto/EuroOffice/IEuroOffice";

// Edycja dokumentów w Euro-Office (ONLYOFFICE Document Server) zamiast w MS Word przez wtyczkę.
// Treść jest szyfrowana E2E, więc Document Server nie czyta jej z S3 wprost: FE odszyfrowuje klucz
// OBIEKTU i oddaje go bramce BE (POST session), a bramka serwuje Document Serverowi jawną treść pod
// jednorazowym tokenem i po zapisie szyfruje ją z powrotem tym samym kluczem.

const queryKeys = {
  status: "euroOfficeService.status",
  document: "euroOfficeService.document",
};

const getStatus = async (): Promise<IEuroOfficeStatus> => {
  const r = await axiosInstance.get("euro-office/status");
  return r.data;
};

/** Czy BE ma skonfigurowany Document Server; bez tego ustawienie „Euro-Office" nie ma czego otworzyć. */
const useGetStatus = () =>
  useCustomQuery(queryKeys.status, () => getStatus(), { staleTime: 5 * 60 * 1000, retry: false });

const getDocument = async (id: string, kind: ItemKind): Promise<IEuroOfficeDocument> => {
  const r = await axiosInstance.get("euro-office/document", { params: { id, kind } });
  return r.data;
};

const useGetDocument = (id: string | undefined, kind: ItemKind | undefined) =>
  useCustomQuery([queryKeys.document, id, kind], () => getDocument(id!, kind!), {
    enabled: !!id && kind !== undefined,
    retry: false,
  });

const createSession = async (payload: IEuroOfficeSessionRequest): Promise<IEuroOfficeSession> => {
  const r = await axiosInstance.post("euro-office/session", payload);
  return r.data;
};

const useCreateSession = () => useCustomMutation(createSession);

/** Adres karty edytora (otwierany w nowej zakładce). */
export const euroOfficeEditorPath = (id: string, kind: ItemKind, versionId?: string | null) =>
  `/euro-office/edit/${kind}/${id}${versionId ? `?version=${encodeURIComponent(versionId)}` : ""}`;

export default {
  queryKeys,
  getStatus,
  useGetStatus,
  getDocument,
  useGetDocument,
  createSession,
  useCreateSession,
};
